import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Drawer, Grid } from "@mui/material";
// import { borderRadius } from "@mui/system";
import { Button, Typography, List, ListItemText, ListItem, ListItemButton, ListItemIcon, } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import RouteIcon from "@mui/icons-material/Route";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import memoji from '../../assets/Memoji.svg';

const dashboardList1 = [
  {
    title: "Track Order",
    icon: <RouteIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "My Activity",
    icon: <BoltOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "Saved Address",
    icon: <GroupsOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "My Payments",
    icon: <CreditCardOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "Favourite",
    icon: <FavoriteBorderOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "Promotions",
    icon: <LocalOfferOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
  {
    title: "Gift Card",
    icon: <WorkspacePremiumOutlinedIcon />,
    arrow: <ArrowForwardIosOutlinedIcon />,
  },
];
export default function SubscriptionHeader({ setshowsubTypeFunc, showsubType }) {
  const navigate = useNavigate();
  const NavigateTo = (url) => {
    navigate(url);
  }
  console.log(showsubType)
  const [navColor, setnavColor] = useState("transparent");
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#F9FFFF") : setnavColor("transparent");
    // window.scrollY > 10 ? setnavSize("5rem") : setnavSize("5rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const [checkLogin, setcheckLogin] = useState(false)
  const loginCheck = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    console.log(loginCheck?.profile?._id)
    if (loginCheck?.profile?._id) {
      setcheckLogin(true)
    }
  }, [loginCheck])

  const [userFullName, setUserFullName] = useState("");
  const [state, setState] = React.useState({
    right: false,
  });
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData !== null)
      setUserFullName(JSON.parse(userData)?.profile?.fullName);
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);


  const handleLogout = () => {
    localStorage.removeItem("navBtn");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setTimeout(() => {
      // setValLocal(false);
      toggleDrawer("right", false);
      window.location.reload(true)
    }, 1000);
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: 377, md: 377, sm: 377, xs: "100%" },
        padding: "32px 16px",
      }}
      role="presentation"
    // onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", flexDirection: "row", pb: "24px" }}>
        <Box sx={{ width: "56px", height: "56px" }}>
          <img
            src="./images/Drop your Memoji here.svg"
            alt=""
            width="100%"
            height="auto"
          />
        </Box>
        <Box sx={{ pl: "16px" }}>
          <Typography
            sx={{
              fontSize: {
                xl: "",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            {userFullName}
          </Typography>
          <Link to="/dashboard" component="button">
            <Typography
              color="primary"
              sx={{
                fontSize: {
                  xl: "",
                  lg: "14px",
                  md: "14px",
                  sm: "14px",
                  xs: "14px",
                },
              }}
            >
              View Profile
            </Typography>
          </Link>
        </Box>
      </Box>

      <List sx={{ color: "#1A1824" }}>
        <ListItemText
          primary={"My Account"}
          sx={{ color: "#9EA3AE", pb: "20px" }}
        ></ListItemText>

        {dashboardList1 &&
          dashboardList1.map((item, index) => (
            <ListItem key={item.title} disablePadding>
              <ListItemButton onClick={() => navigate("/dashboard")}>
                <ListItemIcon
                  sx={{ minWidth: "24px", mr: "10px", color: "#1A1824" }}
                >
                  {/* <img width="100%" src={item.icon} alt="" /> */}
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.title} sx={{ color: "#1A1824" }} />
                {item.arrow}
              </ListItemButton>
            </ListItem>
          ))}

        <ListItem
          disablePadding
          sx={{
            backgroundColor: "#F0FAF9",
            borderRadius: "4px",
            height: "94px",
            pt: "10px",
          }}
        >
          <ListItemButton>
            <ListItemText>
              <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                Get 10% off your order
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "400", color: "#20615C" }}
              >
                Can only be used for today
              </Typography>
            </ListItemText>
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItemText
          primary={"General"}
          sx={{ color: "#9EA3AE", pb: "20px", mt: "8px" }}
        ></ListItemText>

        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/GetHelp")}>
            <ListItemIcon>
              <HelpOutlineOutlinedIcon sx={{ fill: "#1A1824" }} />
            </ListItemIcon>
            <ListItemText primary={"Help"} />
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <WorkspacePremiumOutlinedIcon sx={{ fill: "#E75C62" }} />
            </ListItemIcon>
            <ListItemText primary={"Logout"} sx={{ color: "#E75C62" }} />
            <ArrowForwardIosOutlinedIcon sx={{ fill: "#E75C62" }} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenDrawer(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenDrawer(false);
  };


  const goBack = () => {
    !showsubType ? setshowsubTypeFunc(true) : navigate('/Meal_Plan/undefined')
  }

  return (
    <>
      <Box
        // container

        component="main"
        sx={{
          display: "grid",
          gridAutoColumns: "1fr",
          gap: 1,
          margin: '20px',
          //   backgroundColor: "#E5E5E5"
        }}
      >
        <Box
          sx={{
            gridRow: "1",
            gridColumn: "span 2",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              width: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
              height: { lg: "40px", md: "40px", sm: "36px", xs: "32px" },
              cursor: 'pointer',
            }}
            // onClick={() => navigate('/Meal_Plan')}
            onClick={() => goBack()}
          >
            <img
              src="./images/FrameArrow787.svg"
              alt=""
              width="100%"
            // height="auto"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                width: {
                  lg: "199.91px",
                  md: "199.91px",
                  sm: "190px",
                  xs: "100px",
                },
                height: "32px",
                paddingLeft: "32px",
              }}
            >
              <Button onClick={() => NavigateTo('/')} sx={{ cursor: 'pointer' }}>
                <img src="./images/eatcoast.svg" alt="" width="100%" />
              </Button>
            </Box>
          </Box>
          <Box sx={{}}>
            <Box sx={{ display: "flex", flexDirection: "row", }}>

              {checkLogin ? <Box sx={{
                width: { xl: "60%", lg: "50%", md: "30%" },
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
                // border: "1px solid red"
              }}
              >
                <Button
                  // onClick={console.log("right", true)}
                  onClick={toggleDrawer("right", true)}
                  size="small"
                  sx={{
                    marginLeft: {
                      xl: "8px",
                      lg: "8px",
                      md: "8px",
                      sm: "8px",
                      xs: "4px",
                    },
                    borderRadius: "6px",
                    fontSize: {
                      lg: "16px",
                      md: "12px",
                      sm: "12px",
                      xs: "12px",
                    },
                    fontWeight: "600",
                    height: {
                      lg: "45px",
                      md: "45px",
                      sm: "30px",
                      xs: "22px",
                    },
                    width: { lg: "30px", md: "30px", sm: "30px", xs: "22px" },
                    backgroundColor: "#D5E6E5",
                    border: "none",
                    boxShadow: "0px 0px 0px",

                    // width: "97px",
                  }}
                  variant="contained"
                >
                  <img src={memoji} />
                </Button>
                <Drawer
                  anchor={"right"}
                  open={state["right"]}
                  onClose={toggleDrawer("right", false)}
                >
                  {list("right")}
                </Drawer>
              </Box> :
                <Button onClick={() => NavigateTo('/login')} sx={{
                  marginLeft: "10px", borderRadius: "6px", fontSize: "16px", fontWeight: "600",
                  textTransform: "capitalize", width: "97px", height: "40px"
                }} variant="contained">
                  Sign In
                </Button>}
              {/* </Link> */}



            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
